/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import {
  Address,
  Contract,
  ContractState,
  TestContractResult,
  HexString,
  ContractFactory,
  EventSubscribeOptions,
  EventSubscription,
  CallContractParams,
  CallContractResult,
  TestContractParams,
  ContractEvent,
  subscribeContractEvent,
  subscribeContractEvents,
  testMethod,
  callMethod,
  multicallMethods,
  fetchContractState,
  Asset,
  ContractInstance,
  getContractEventsCurrentCount,
  TestContractParamsWithoutMaps,
  TestContractResultWithoutMaps,
  SignExecuteContractMethodParams,
  SignExecuteScriptTxResult,
  signExecuteMethod,
  addStdIdToFields,
  encodeContractFields,
  Narrow,
} from "@alephium/web3";
import { default as LeaderboardContractJson } from "../lib/leaderboard/Leaderboard.ral.json";
import { getContractByCodeHash, registerContract } from "./contracts";
import {
  LeaderboardEntry,
  LeaderboardPeriodicTop,
  RocketRangeGameInstance,
  RocketRangeGameSettings,
  RocketRangeOracleValue,
  RocketRangeUserBet,
  UpgradableSettings,
  AllStructs,
} from "./types";
import { RalphMap } from "@alephium/web3";

// Custom types for the contract
export namespace LeaderboardTypes {
  export type Fields = {
    scoreUpdater: Address;
    currentTop: LeaderboardPeriodicTop;
  };

  export type State = ContractState<Fields>;

  export type EntryUpdateEvent = ContractEvent<{
    userAddr: Address;
    periodicScore: bigint;
    totalScore: bigint;
  }>;
  export type DistributeRewardsEvent = ContractEvent<{
    firstAddr: Address;
    firstAmount: bigint;
    secondAddr: Address;
    secondAmount: bigint;
    thirdAddr: Address;
    thirdAmount: bigint;
    totalRewards: bigint;
  }>;
  export type RewardPoolUpdatedEvent = ContractEvent<{
    callerAddr: Address;
    rewardPool: bigint;
  }>;

  export interface CallMethodTable {
    addScore: {
      params: CallContractParams<{
        userAddr: Address;
        score: bigint;
        feePayer: Address;
      }>;
      result: CallContractResult<null>;
    };
    addToRewardPool: {
      params: CallContractParams<{ payer: Address; amount: bigint }>;
      result: CallContractResult<null>;
    };
    updateTopEntries: {
      params: CallContractParams<{ entry: LeaderboardEntry }>;
      result: CallContractResult<null>;
    };
    resetLeaderboardPeriod: {
      params: Omit<CallContractParams<{}>, "args">;
      result: CallContractResult<null>;
    };
    loadLeaderboardEntry: {
      params: CallContractParams<{ user: Address }>;
      result: CallContractResult<[boolean, LeaderboardEntry]>;
    };
    saveLeaderboardEntry: {
      params: CallContractParams<{
        feePayer: Address;
        entry: LeaderboardEntry;
      }>;
      result: CallContractResult<null>;
    };
    emptyLeaderboardEntry: {
      params: Omit<CallContractParams<{}>, "args">;
      result: CallContractResult<LeaderboardEntry>;
    };
  }
  export type CallMethodParams<T extends keyof CallMethodTable> =
    CallMethodTable[T]["params"];
  export type CallMethodResult<T extends keyof CallMethodTable> =
    CallMethodTable[T]["result"];
  export type MultiCallParams = Partial<{
    [Name in keyof CallMethodTable]: CallMethodTable[Name]["params"];
  }>;
  export type MultiCallResults<T extends MultiCallParams> = {
    [MaybeName in keyof T]: MaybeName extends keyof CallMethodTable
      ? CallMethodTable[MaybeName]["result"]
      : undefined;
  };
  export type MulticallReturnType<Callss extends MultiCallParams[]> = {
    [index in keyof Callss]: MultiCallResults<Callss[index]>;
  };

  export interface SignExecuteMethodTable {
    addScore: {
      params: SignExecuteContractMethodParams<{
        userAddr: Address;
        score: bigint;
        feePayer: Address;
      }>;
      result: SignExecuteScriptTxResult;
    };
    addToRewardPool: {
      params: SignExecuteContractMethodParams<{
        payer: Address;
        amount: bigint;
      }>;
      result: SignExecuteScriptTxResult;
    };
    updateTopEntries: {
      params: SignExecuteContractMethodParams<{ entry: LeaderboardEntry }>;
      result: SignExecuteScriptTxResult;
    };
    resetLeaderboardPeriod: {
      params: Omit<SignExecuteContractMethodParams<{}>, "args">;
      result: SignExecuteScriptTxResult;
    };
    loadLeaderboardEntry: {
      params: SignExecuteContractMethodParams<{ user: Address }>;
      result: SignExecuteScriptTxResult;
    };
    saveLeaderboardEntry: {
      params: SignExecuteContractMethodParams<{
        feePayer: Address;
        entry: LeaderboardEntry;
      }>;
      result: SignExecuteScriptTxResult;
    };
    emptyLeaderboardEntry: {
      params: Omit<SignExecuteContractMethodParams<{}>, "args">;
      result: SignExecuteScriptTxResult;
    };
  }
  export type SignExecuteMethodParams<T extends keyof SignExecuteMethodTable> =
    SignExecuteMethodTable[T]["params"];
  export type SignExecuteMethodResult<T extends keyof SignExecuteMethodTable> =
    SignExecuteMethodTable[T]["result"];

  export type Maps = { leaderboardCollection?: Map<Address, LeaderboardEntry> };
}

class Factory extends ContractFactory<
  LeaderboardInstance,
  LeaderboardTypes.Fields
> {
  encodeFields(fields: LeaderboardTypes.Fields) {
    return encodeContractFields(
      addStdIdToFields(this.contract, fields),
      this.contract.fieldsSig,
      AllStructs
    );
  }

  eventIndex = { EntryUpdate: 0, DistributeRewards: 1, RewardPoolUpdated: 2 };

  at(address: string): LeaderboardInstance {
    return new LeaderboardInstance(address);
  }

  tests = {
    addScore: async (
      params: TestContractParams<
        LeaderboardTypes.Fields,
        { userAddr: Address; score: bigint; feePayer: Address },
        LeaderboardTypes.Maps
      >
    ): Promise<TestContractResult<null, LeaderboardTypes.Maps>> => {
      return testMethod(this, "addScore", params, getContractByCodeHash);
    },
    addToRewardPool: async (
      params: TestContractParams<
        LeaderboardTypes.Fields,
        { payer: Address; amount: bigint },
        LeaderboardTypes.Maps
      >
    ): Promise<TestContractResult<null, LeaderboardTypes.Maps>> => {
      return testMethod(this, "addToRewardPool", params, getContractByCodeHash);
    },
    updateTopEntries: async (
      params: TestContractParams<
        LeaderboardTypes.Fields,
        { entry: LeaderboardEntry },
        LeaderboardTypes.Maps
      >
    ): Promise<TestContractResult<null, LeaderboardTypes.Maps>> => {
      return testMethod(
        this,
        "updateTopEntries",
        params,
        getContractByCodeHash
      );
    },
    resetLeaderboardPeriod: async (
      params: Omit<
        TestContractParams<
          LeaderboardTypes.Fields,
          never,
          LeaderboardTypes.Maps
        >,
        "testArgs"
      >
    ): Promise<TestContractResult<null, LeaderboardTypes.Maps>> => {
      return testMethod(
        this,
        "resetLeaderboardPeriod",
        params,
        getContractByCodeHash
      );
    },
    loadLeaderboardEntry: async (
      params: TestContractParams<
        LeaderboardTypes.Fields,
        { user: Address },
        LeaderboardTypes.Maps
      >
    ): Promise<
      TestContractResult<[boolean, LeaderboardEntry], LeaderboardTypes.Maps>
    > => {
      return testMethod(
        this,
        "loadLeaderboardEntry",
        params,
        getContractByCodeHash
      );
    },
    saveLeaderboardEntry: async (
      params: TestContractParams<
        LeaderboardTypes.Fields,
        { feePayer: Address; entry: LeaderboardEntry },
        LeaderboardTypes.Maps
      >
    ): Promise<TestContractResult<null, LeaderboardTypes.Maps>> => {
      return testMethod(
        this,
        "saveLeaderboardEntry",
        params,
        getContractByCodeHash
      );
    },
    emptyLeaderboardEntry: async (
      params: Omit<
        TestContractParams<
          LeaderboardTypes.Fields,
          never,
          LeaderboardTypes.Maps
        >,
        "testArgs"
      >
    ): Promise<TestContractResult<LeaderboardEntry, LeaderboardTypes.Maps>> => {
      return testMethod(
        this,
        "emptyLeaderboardEntry",
        params,
        getContractByCodeHash
      );
    },
  };

  stateForTest(
    initFields: LeaderboardTypes.Fields,
    asset?: Asset,
    address?: string,
    maps?: LeaderboardTypes.Maps
  ) {
    return this.stateForTest_(initFields, asset, address, maps);
  }
}

// Use this object to test and deploy the contract
export const Leaderboard = new Factory(
  Contract.fromJson(
    LeaderboardContractJson,
    "=26+e=1-1=2-1=1+8=1725-1+a=169-1+f=40+7a7e0214696e73657274206174206d617020706174683a2000=46",
    "4e655a226d321b21d2f29460bec40cbb72530d5a05e87ce48a62a9d5f4625773",
    AllStructs
  )
);
registerContract(Leaderboard);

// Use this class to interact with the blockchain
export class LeaderboardInstance extends ContractInstance {
  constructor(address: Address) {
    super(address);
  }

  maps = {
    leaderboardCollection: new RalphMap<Address, LeaderboardEntry>(
      Leaderboard.contract,
      this.contractId,
      "leaderboardCollection"
    ),
  };

  async fetchState(): Promise<LeaderboardTypes.State> {
    return fetchContractState(Leaderboard, this);
  }

  async getContractEventsCurrentCount(): Promise<number> {
    return getContractEventsCurrentCount(this.address);
  }

  subscribeEntryUpdateEvent(
    options: EventSubscribeOptions<LeaderboardTypes.EntryUpdateEvent>,
    fromCount?: number
  ): EventSubscription {
    return subscribeContractEvent(
      Leaderboard.contract,
      this,
      options,
      "EntryUpdate",
      fromCount
    );
  }

  subscribeDistributeRewardsEvent(
    options: EventSubscribeOptions<LeaderboardTypes.DistributeRewardsEvent>,
    fromCount?: number
  ): EventSubscription {
    return subscribeContractEvent(
      Leaderboard.contract,
      this,
      options,
      "DistributeRewards",
      fromCount
    );
  }

  subscribeRewardPoolUpdatedEvent(
    options: EventSubscribeOptions<LeaderboardTypes.RewardPoolUpdatedEvent>,
    fromCount?: number
  ): EventSubscription {
    return subscribeContractEvent(
      Leaderboard.contract,
      this,
      options,
      "RewardPoolUpdated",
      fromCount
    );
  }

  subscribeAllEvents(
    options: EventSubscribeOptions<
      | LeaderboardTypes.EntryUpdateEvent
      | LeaderboardTypes.DistributeRewardsEvent
      | LeaderboardTypes.RewardPoolUpdatedEvent
    >,
    fromCount?: number
  ): EventSubscription {
    return subscribeContractEvents(
      Leaderboard.contract,
      this,
      options,
      fromCount
    );
  }

  view = {
    addScore: async (
      params: LeaderboardTypes.CallMethodParams<"addScore">
    ): Promise<LeaderboardTypes.CallMethodResult<"addScore">> => {
      return callMethod(
        Leaderboard,
        this,
        "addScore",
        params,
        getContractByCodeHash
      );
    },
    addToRewardPool: async (
      params: LeaderboardTypes.CallMethodParams<"addToRewardPool">
    ): Promise<LeaderboardTypes.CallMethodResult<"addToRewardPool">> => {
      return callMethod(
        Leaderboard,
        this,
        "addToRewardPool",
        params,
        getContractByCodeHash
      );
    },
    updateTopEntries: async (
      params: LeaderboardTypes.CallMethodParams<"updateTopEntries">
    ): Promise<LeaderboardTypes.CallMethodResult<"updateTopEntries">> => {
      return callMethod(
        Leaderboard,
        this,
        "updateTopEntries",
        params,
        getContractByCodeHash
      );
    },
    resetLeaderboardPeriod: async (
      params?: LeaderboardTypes.CallMethodParams<"resetLeaderboardPeriod">
    ): Promise<LeaderboardTypes.CallMethodResult<"resetLeaderboardPeriod">> => {
      return callMethod(
        Leaderboard,
        this,
        "resetLeaderboardPeriod",
        params === undefined ? {} : params,
        getContractByCodeHash
      );
    },
    loadLeaderboardEntry: async (
      params: LeaderboardTypes.CallMethodParams<"loadLeaderboardEntry">
    ): Promise<LeaderboardTypes.CallMethodResult<"loadLeaderboardEntry">> => {
      return callMethod(
        Leaderboard,
        this,
        "loadLeaderboardEntry",
        params,
        getContractByCodeHash
      );
    },
    saveLeaderboardEntry: async (
      params: LeaderboardTypes.CallMethodParams<"saveLeaderboardEntry">
    ): Promise<LeaderboardTypes.CallMethodResult<"saveLeaderboardEntry">> => {
      return callMethod(
        Leaderboard,
        this,
        "saveLeaderboardEntry",
        params,
        getContractByCodeHash
      );
    },
    emptyLeaderboardEntry: async (
      params?: LeaderboardTypes.CallMethodParams<"emptyLeaderboardEntry">
    ): Promise<LeaderboardTypes.CallMethodResult<"emptyLeaderboardEntry">> => {
      return callMethod(
        Leaderboard,
        this,
        "emptyLeaderboardEntry",
        params === undefined ? {} : params,
        getContractByCodeHash
      );
    },
  };

  transact = {
    addScore: async (
      params: LeaderboardTypes.SignExecuteMethodParams<"addScore">
    ): Promise<LeaderboardTypes.SignExecuteMethodResult<"addScore">> => {
      return signExecuteMethod(Leaderboard, this, "addScore", params);
    },
    addToRewardPool: async (
      params: LeaderboardTypes.SignExecuteMethodParams<"addToRewardPool">
    ): Promise<LeaderboardTypes.SignExecuteMethodResult<"addToRewardPool">> => {
      return signExecuteMethod(Leaderboard, this, "addToRewardPool", params);
    },
    updateTopEntries: async (
      params: LeaderboardTypes.SignExecuteMethodParams<"updateTopEntries">
    ): Promise<
      LeaderboardTypes.SignExecuteMethodResult<"updateTopEntries">
    > => {
      return signExecuteMethod(Leaderboard, this, "updateTopEntries", params);
    },
    resetLeaderboardPeriod: async (
      params: LeaderboardTypes.SignExecuteMethodParams<"resetLeaderboardPeriod">
    ): Promise<
      LeaderboardTypes.SignExecuteMethodResult<"resetLeaderboardPeriod">
    > => {
      return signExecuteMethod(
        Leaderboard,
        this,
        "resetLeaderboardPeriod",
        params
      );
    },
    loadLeaderboardEntry: async (
      params: LeaderboardTypes.SignExecuteMethodParams<"loadLeaderboardEntry">
    ): Promise<
      LeaderboardTypes.SignExecuteMethodResult<"loadLeaderboardEntry">
    > => {
      return signExecuteMethod(
        Leaderboard,
        this,
        "loadLeaderboardEntry",
        params
      );
    },
    saveLeaderboardEntry: async (
      params: LeaderboardTypes.SignExecuteMethodParams<"saveLeaderboardEntry">
    ): Promise<
      LeaderboardTypes.SignExecuteMethodResult<"saveLeaderboardEntry">
    > => {
      return signExecuteMethod(
        Leaderboard,
        this,
        "saveLeaderboardEntry",
        params
      );
    },
    emptyLeaderboardEntry: async (
      params: LeaderboardTypes.SignExecuteMethodParams<"emptyLeaderboardEntry">
    ): Promise<
      LeaderboardTypes.SignExecuteMethodResult<"emptyLeaderboardEntry">
    > => {
      return signExecuteMethod(
        Leaderboard,
        this,
        "emptyLeaderboardEntry",
        params
      );
    },
  };

  async multicall<Calls extends LeaderboardTypes.MultiCallParams>(
    calls: Calls
  ): Promise<LeaderboardTypes.MultiCallResults<Calls>>;
  async multicall<Callss extends LeaderboardTypes.MultiCallParams[]>(
    callss: Narrow<Callss>
  ): Promise<LeaderboardTypes.MulticallReturnType<Callss>>;
  async multicall<
    Callss extends
      | LeaderboardTypes.MultiCallParams
      | LeaderboardTypes.MultiCallParams[]
  >(callss: Callss): Promise<unknown> {
    return await multicallMethods(
      Leaderboard,
      this,
      callss,
      getContractByCodeHash
    );
  }
}
